import { GpsAuthStrategyEnum } from '../enums/gps-auth-strategy.enum';

export interface IIntegrationProvider {
    id: number;
    trackingProviderId: number;
    authStrategy: GpsAuthStrategyEnum;
    apiKey: string | null;
    ipList: string | null;
    isActive: boolean;
    createdAt: Date;
    updatedAt: Date;
}
